import { AccountOut } from '../../../../store/api';
import { http } from '../../../../api/axios';
import { shopPrefix } from '../../../../config';

const endpoint = `${shopPrefix}/v1/reservelist/:reserveListId/checkout/accounts/suggest`;

export const fetchReserveListCheckoutAccountSuggestion = async (reserveListId: string) => {
    return http
        .get<{ suggestedAccount: AccountOut }>(endpoint, {
            pathParams: {
                reserveListId
            }
        })
        .then(response => response.data.suggestedAccount);
};
